/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const isStringEqual = (a: string, b: string) => a.toUpperCase() === b.toUpperCase();
